import script from "./Create.vue?vue&type=script&lang=ts&setup=true"
export * from "./Create.vue?vue&type=script&lang=ts&setup=true"

import "./Create.vue?vue&type=style&index=0&id=452dd2cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452dd2cc"]])

export default __exports__